import React from "react";
import OrgTokenCard from "src/scenes/developer-portal/org-token-card";
import { Grid } from "@mui/material";
import RevokeTokenModal from "src/scenes/developer-portal/revoke-token-modal";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import styled from "styled-components";
import Link from "@mui/material/Link";
import OrgIdCard from "./org-id-card";

const Header = styled.h2`
    margin-bottom: 0;
`;

const Description = styled.p`
    font-size: 12px;
`;
const DeveloperPortal = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [organizationToken, setOrganizationToken] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const { isDemo } = useAuth();

    const getOrganizationToken = async () => {
        let response;
        if (isDemo) {
            response = null;
        } else {
            response = await request(`api/users/token`, { method: "GET" });
        }
        setOrganizationToken(response);
        setLoading(false);
    };

    React.useEffect(() => {
        getOrganizationToken();
    }, []);

    return (
        <Grid container direction="column" spacing={2}>
            <Grid item ml={2}>
                <Header>Developer Portal</Header>
            </Grid>
            <Grid item ml={2}>
                <Description>
                    You can create an organization API token for use with our external bolt app and{" "}
                    <Link href="https://adadothelp.document360.io/docs/webhooks">
                        custom deployment webhooks
                    </Link>
                    . You can find the Slack Bolt App{" "}
                    <Link href="https://github.com/AdadotTeam/slack-event-listener">here</Link>
                </Description>
            </Grid>
            <Grid item>
                <OrgIdCard />
            </Grid>
            <Grid item>
                <OrgTokenCard
                    organizationToken={organizationToken}
                    setOrganizationToken={setOrganizationToken}
                    setIsModalOpen={setIsModalOpen}
                    loading={loading}
                    setLoading={setLoading}
                />
            </Grid>
            <RevokeTokenModal
                open={isModalOpen}
                setOrganizationToken={setOrganizationToken}
                handleClose={() => setIsModalOpen(false)}
                loading={loading}
                setLoading={setLoading}
            />
        </Grid>
    );
};

export default DeveloperPortal;
